import React from 'react';
import { Pressable, PressableProps } from 'react-native';
import { testIdentifiers } from 'utils/testIdentifiers';

interface TouchableItemProps extends PressableProps {
  testID?: string;
  accessibilityLabel?: string;
  disabled?: boolean;
  children: React.ReactNode;
  justifyContent?: 'flex-start' | 'center' | 'space-between';
}

/**
 * A reusable Pressable component with consistent styling and accessibility
 */
const TouchableItem: React.FC<TouchableItemProps> = ({
  testID,
  accessibilityLabel,
  disabled = false,
  children,
  onPress,
  justifyContent = 'space-between',
  ...rest
}) => {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [
        {
          opacity: pressed ? 0.5 : 1,
          flexDirection: 'column',
          justifyContent,
          alignItems: 'stretch',
        },
      ]}
      {...(testID ? testIdentifiers(testID) : {})}
      accessible={true}
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      disabled={disabled}
      {...rest}>
      {children}
    </Pressable>
  );
};

export default TouchableItem;
